import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const RecipeService = {
  // ✅ Updated getList with SearchText and pagination params
  getList: async ({ SearchText = "", pageNumber = 1, pageSize = 10 } = {}) => {
    const params = new URLSearchParams({
      ...(SearchText && { SearchText: SearchText.toString() }),
      pageNumber: pageNumber.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(
      `/productrecipemain?${params.toString()}`,
      {
        headers: {
          authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      }
    );
    return response.data;
  },

  create: async (data) => {
    const response = await apiService.post("/productrecipemain", data, {
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },

  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/productrecipemain/${id}`,
        updatedData,
        {
          headers: {
            authorization: "Bearer " + _BaseAPIService.retrieveToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating recipe:", error);
      throw error;
    }
  },

  getDetail: async (id) => {
    const response = await apiService.get(`/productrecipemain/${id}`, {
      headers: {
        Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/productrecipemain/${id}`, {
      headers: {
        authorization: "Bearer " + _BaseAPIService.retrieveToken(),
      },
    });
    return response.data;
  },
};

export default RecipeService;
